import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { asAgentsTab, type AgentsTab } from '@/features/ai/ai-href';
import { ProjectAgentsPage } from '@/features/ai/agents/agents-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Projet → « Agents » : agents connectés, fil en direct (SSE), validations. */
export const Route = createFileRoute('/$tenant/projects/$projectId/agents')({
  validateSearch: (search: Record<string, unknown>): { tab: AgentsTab } => ({
    tab: asAgentsTab(search['tab']),
  }),
  component: ProjectAgentsRoute,
});

function ProjectAgentsRoute() {
  const { tenant, projectId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="agents"
      crumbs={[{ label: t('nav.items.agents') }]}
    >
      <ProjectAgentsPage
        tenantId={tenant}
        projectId={projectId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
